import React from "react";

export const StatCard = ({ label, value, note }) => (
  <div data-testid="stat-card" className="rounded-[14px] border p-5" style={{ background: "var(--surface)", borderColor: "var(--card-border)" }}>
    <p className="motif-caps">{label}</p>
    <p className="mt-3 text-3xl font-semibold tracking-[-0.02em]" style={{ color: "var(--text)" }}>{value}</p>
    {note && <p className="mt-1 text-xs" style={{ color: "var(--muted)" }}>{note}</p>}
  </div>
);
